import emailjs from '@emailjs/browser'

// EmailJS Configuration
const EMAILJS_SERVICE_ID = process.env.VUE_APP_EMAILJS_SERVICE_ID
const EMAILJS_TEMPLATE_ID = process.env.VUE_APP_EMAILJS_TEMPLATE_ID
const EMAILJS_PUBLIC_KEY = process.env.VUE_APP_EMAILJS_PUBLIC_KEY

// Initialize EmailJS
emailjs.init(EMAILJS_PUBLIC_KEY)

/**
 * Send service request notification email
 * @param {Object} requestData - The service request data
 * @returns {Promise} EmailJS response
 */
export const sendServiceRequestEmail = async (requestData) => {
  try {
    const templateParams = {
      to_email: 'kontakt@vi-gas.pl', // Your email address
      from_name: 'System Zgłoszeń VI-GAS',
      address: requestData.address,
      boiler_type: requestData.boiler_type,
      phone: requestData.phone,
      description: requestData.description,
      request_date: new Date().toLocaleString('pl-PL'),
      status: requestData.status || 'new'
    }

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    )

    console.log('Email sent successfully:', response)
    return response
  } catch (error) {
    console.error('Error sending email:', error)
    throw error
  }
}

export default {
  sendServiceRequestEmail
}
